<template>
  <div class="base-set-wrap">
    <div class="card-header">
      <span class="title-text">基础设置 <span :class="showTips ? 'el-form-item__error' : 'hidden_error'">请补充完基础设置</span></span>
      <el-button class="add-plan" type="text" @click="showDrawerBox">
        <svg-icon iconClass="edit" className="edit-btn"></svg-icon>编辑</el-button
      >
    </div>
    <div class="set-form">
      <div class="form-item">
        <span class="item-lable">广告名称：</span>
        <span class="item-value">{{ format_draft_adset }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">应用ID：</span>
        <span class="item-value" v-if="draft_adset.promotedObjectName"
          >{{ draft_adset.promotedObjectName }}(ID：{{ draft_adset.promotedObjectId }})</span
        >
        <span class="item-value" v-else>-</span>
      </div>
      <div class="form-item" v-if="format_ad_channel">
        <span class="item-lable">渠道包：</span>
        <span class="item-value">{{ format_ad_channel }}</span>
      </div>
      <div class="form-item">
        <span class="item-lable">广告版位：</span>
        <span class="item-value">{{ format_ad_position }}</span>
      </div>
    </div>
    <!-- 抽屉 -->
    <el-drawer
      title="基础设置"
      :visible.sync="showDrawer"
      size="674px"
      :show-close="false"
      class="drawer-wrap"
      @open="openDrawer"
      :before-close="beforeDrawerClosed"
    >
      <edit-base-set
        ref="basesetRef"
        @showAddProductFigureDialog="showAddProductFigureDialog"
        @showAddCustomLabelDialog="showAddCustomLabelDialog"
      ></edit-base-set>
    </el-drawer>
    <!-- 自定义标签弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      title="提示"
      custom-class="edit-base-add-custom-label"
      :visible.sync="addLableDialogVisible"
      width="30%"
    >
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入自定义标签，单标签2-7字，一行一个,回车换行可添加多个"
        v-model="customLabelTextarea"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addLableDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlerConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 素材选择弹框 -->
    <material-modal
      ref="materialModalRef"
      @selectOk="selectedMaterial"
      :selectType="curMaterialType"
      :showGroupNum="showGroupNum"
      :singleSelect="true"
      fileMode="BRAND_IMAGE_MODE"
    ></material-modal>
    <!-- 创建品牌弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="modalType === BRAND ? '创建品牌形象' : '创建挂件图'"
      custom-class="edit-base-add-custom-label"
      :visible.sync="addProductFigureVisible"
      width="30%"
    >
      <el-form v-if="modalType === BRAND" :model="productForm" ref="ruleForm" label-width="100px">
        <el-form-item label="创建方式：" prop="createType">
          <el-radio-group v-model="productForm.createType" size="mini">
            <el-radio-button label="new">新建</el-radio-button>
            <el-radio-button label="export">导入</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <div v-if="productForm.createType === 'new'">
          <el-form-item label="名称：" prop="name">
            <el-input maxlength="12" show-word-limit v-model="productForm.name"></el-input>
          </el-form-item>
          <el-form-item label="ICON：">
            <div class="icon-content">
              <img
                @mouseenter="isMouseCover = true"
                @mouseleave="isMouseCover = false"
                v-if="productForm.icon"
                class="icon-img"
                :src="productForm.icon"
              />
              <div v-else>
                <i class="el-icon-upload el-icon--right"></i>
                <el-button class="add-btn" type="primary" @click="showMaterialModal(true)">素材中心</el-button>
              </div>
              <div v-if="isMouseCover" class="cover-btn" @mouseenter="isMouseCover = true">
                <el-button class="add-btn" type="primary" @click="showMaterialModal(true)">素材中心</el-button>
              </div>
            </div>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="广告账户：" prop="adCount">
            <el-select
              v-model="productForm.adCount"
              multiple
              placeholder="请选择"
              style="width: 400px"
              popper-class="base-set-wrap-count-select"
            >
              <el-option v-for="item of countList" :key="item.advertiserId" :label="item.advertiserId" :value="item.advertiserId">
                <div class="count-option">
                  <span class="count-item">{{ item.company }}-{{ item.advertiserName }}</span>
                  <span class="count-item">ID：{{ item.advertiserId }}</span>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <div class="app-list">
            <el-checkbox-group v-model="productForm.checkList">
              <el-checkbox v-for="(item, index) in appList" :key="index" :label="item" class="app-item">
                <img :src="item.imageUrl" class="app-pic" />
                <span class="app-name">{{ item.name }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-form>
      <el-form v-else :model="pendantForm" ref="pendantRuleForm" label-width="100px">
        <el-form-item label="名称：" prop="name">
          <el-input maxlength="9" show-word-limit v-model="pendantForm.name"></el-input>
        </el-form-item>
        <el-form-item label="ICON：">
          <div class="icon-content">
            <img
              @mouseenter="isMouseCover = true"
              @mouseleave="isMouseCover = false"
              v-if="pendantForm.icon"
              class="icon-img"
              :src="pendantForm.icon"
            />
            <div v-else>
              <i class="el-icon-upload el-icon--right"></i>
              <el-button class="add-btn" type="primary" @click="showMaterialModal(true)">素材中心</el-button>
            </div>
            <div v-if="isMouseCover" class="cover-btn" @mouseenter="isMouseCover = true">
              <el-button class="add-btn" type="primary" @click="showMaterialModal(true)">素材中心</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div v-if="productForm.createType !== 'new' && modalType === BRAND">
        合计导入 {{ productForm.checkList.length }} / {{ appList.length }}个
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addProductFigureVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlerAddBrand">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import EditBaseSet from "./editBaseSet.vue";
import { mapState } from "vuex";
import MaterialModal from "./subBaseset/sub/materialModal.vue";
import { getAdCountList, getBrandAppList, addImageTemplatel, createBrand } from "@/api/promotion-gdt.js";
import nameTransforUtil from "../subPlan/common/nameTransforUtil";
import { videoSelectListOptions, gameSelectListOptions } from "./common/config";

const BRAND = "brand"; // 品牌弹窗
export default {
  components: {
    SvgIcon,
    EditBaseSet,
    MaterialModal,
  },
  data() {
    return {
      videoSelectListOptions,
      gameSelectListOptions,
      BRAND,
      showDrawer: false,
      showTips: false,
      addLableDialogVisible: false,
      customLabelTextarea: "",
      addProductFigureVisible: false,
      modalType: "",
      showGroupNum: false, //是否批量添加创意组
      curMaterialType: "image",
      isMouseCover: false,
      productForm: {
        createType: "new",
        name: "",
        icon: "",
        adCount: "",
        checkList: [],
      },
      pendantForm: {
        createType: "new",
        name: "",
        icon: "",
      },
      countList: [],
      appList: [],
    };
  },
  methods: {
    initSelect() {
      getAdCountList({ platType: 2 }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
      this.productForm.adCount = this.advertiserIdList;
    },
    showDrawerBox() {
      if (this.adCount?.length > 0) {
        this.showDrawer = true;
        this.$refs.basesetRef?.getAppList();
      } else {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      }
    },
    openDrawer() {
      //弹框打开查询表单数据
      this.$nextTick(() => {
        this.$refs.basesetRef.initFormData();
      });
    },
    beforeDrawerClosed(done) {
      //数据格式校验，显示校验标识
      this.$refs.basesetRef.saveDataInStore();
      this.checkData();
      done();
    },
    controlTips(data) {
      this.showTips = data;
    },
    async checkData() {
      if (this.$refs.basesetRef) {
        return await this.$refs.basesetRef
          .checkCurData()
          .then(() => {
            this.controlTips(false);
            return Promise.resolve();
          })
          .catch(() => {
            this.controlTips(true);
            return Promise.reject();
          });
      } else {
        //存在广告计划名称但是组件没有挂载说明选择了模板
        if (this.format_draft_adset !== "-" && this.draft_adset.promotedObjectId) {
          this.controlTips(false);
          return Promise.resolve();
        } else {
          this.controlTips(true);
          return Promise.reject();
        }
      }
    },
    handlerAddBrand() {
      const isBrand = this.modalType === BRAND;
      const imageTemplates = this.productForm.checkList.map((item) => {
        return {
          imageUrl: item.imageUrl,
          name: item.name,
          imageId: item.imageId,
          platType: 2,
          type: isBrand ? 1 : 2,
        };
      });
      const addImage = [
        {
          imageUrl: isBrand ? this.productForm.icon : this.pendantForm.icon,
          name: isBrand ? this.productForm.name : this.pendantForm.name,
          platType: 2,
          type: isBrand ? 1 : 2,
        },
      ];
      if (isBrand) {
        createBrand({
          accountIds: this.advertiserIdList,
          imageTemplates: this.productForm.createType === "new" ? addImage : imageTemplates,
        }).then((res) => {
          if (res.code === "0000") {
            isBrand ? this.$refs.basesetRef.getBrandImageList() : this.$refs.basesetRef.getPendantImageList();
            this.addProductFigureVisible = false;
            this.$message({
              message: "添加成功",
              type: "success",
            });
          }
        });
      } else {
        addImageTemplatel({
          accountIds: this.advertiserIdList,
          imageTemplates: this.productForm.createType === "new" ? addImage : imageTemplates,
        }).then((res) => {
          if (res.code === "0000") {
            isBrand ? this.$refs.basesetRef.getBrandImageList() : this.$refs.basesetRef.getPendantImageList();
            this.addProductFigureVisible = false;
            this.$message({
              message: "添加成功",
              type: "success",
            });
          }
        });
      }
    },
    showAddCustomLabelDialog() {
      this.customLabelTextarea = "";
      this.addLableDialogVisible = true;
    },
    showAddProductFigureDialog(key) {
      if (key === BRAND) {
        this.initSelect();
      }
      this.modalType = key;
      this.productForm = {
        createType: "new",
        name: "",
        icon: "",
        adCount: "",
        checkList: [],
      };
      (this.pendantForm = {
        createType: "new",
        name: "",
        icon: "",
      }),
        (this.addProductFigureVisible = true);
    },
    handlerConfirm() {
      let flag = true;
      this.customLabelTextarea.split(`\n`).map((item) => {
        if (item.length > 7 || item.length < 2) {
          flag = false;
        }
      });
      if (flag) {
        this.addLableDialogVisible = false;
        this.$refs.basesetRef.addCustomLable(this.customLabelTextarea);
      } else {
        this.$message.warning("每个标签长度为2-7字");
      }
    },
    /**
     * flag: 素材组件内部是否展示分组信息
     * type: 素材组件展示的素材类型
     */
    showMaterialModal(flag, type) {
      this.showGroupNum = flag;
      type && (this.curMaterialType = type);
      this.$nextTick(() => {
        this.$refs.materialModalRef.showModal();
      });
    },
    selectedMaterial(resData) {
      let { mapList, groupNum } = resData;
      if (groupNum) {
        this.modalType === BRAND
          ? (this.productForm.icon = Object.values(mapList)[0].path)
          : (this.pendantForm.icon = Object.values(mapList)[0].path);
      }
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount,
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      promotedObjectType: (state) => state.PromotionGdt.promotedObjectType,
      draft_adset: (state) => state.PromotionGdt.draft_adset,
    }),
    format_draft_adset() {
      return this.draft_adset.nameRule ? nameTransforUtil.apiDatatoShow(this.draft_adset.nameRule) : "-";
    },
    format_ad_position() {
      const { placementType, videoCheckList, gameCheckList, videoOtherSelect } = this.draft_adset || {};
      let nameList = [];
      if (placementType === "AUTO") {
        return "自动版位";
      } else if (placementType === "VIDEO") {
        videoCheckList?.map((item) => {
          const findObj = videoSelectListOptions.find((child) => child.value === item) || {};
          nameList.push(findObj.label);
        });
        if (videoOtherSelect === "SITE_SET_MOMENTS") {
          nameList.push("微信朋友圈");
        }
        if (videoOtherSelect === "SITE_SET_QQSHOPPING") {
          nameList.push("QQ购物");
        }
        return nameList?.join("，");
      } else {
        gameCheckList?.map((item) => {
          const findObj = gameSelectListOptions.find((child) => child.value === item) || {};
          nameList.push(findObj.label);
        });
        return nameList?.join("，");
      }
    },
    format_ad_channel() {
      if (this.draft_adset.channelPackageItems && this.draft_adset.channelPackageItems[0]?.sourceAccountId) {
        let nameArray = [];
        this.draft_adset.channelPackageItems.map((item) => {
          if (this.draft_adset.channelPackageItems.length > 1) {
            nameArray.push(`${item.packageName}(${item.sourceAccountId})`);
          } else {
            nameArray.push(`${item.packageName}`);
          }
        });
        return nameArray.join(",");
      } else {
        return false;
      }
    },
  },
  watch: {
    "productForm.adCount": {
      handler(val) {
        if (val.length > 0) {
          this.productForm.checkList = [];
          getBrandAppList({
            accountIds: val,
          }).then((res) => {
            this.appList = res.data;
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.base-set-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    display: flex;
    justify-content: space-between;
    position: relative;
    .title-text {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
      .el-form-item__error {
        font-size: 12px;
        color: #f56c6c;
        font-weight: normal;
        top: 2px;
        left: 78px;
      }
      .hidden_error {
        font-size: 0;
      }
    }
    .edit-btn {
      margin-right: 6px;
      font-size: 14px;
    }
  }
  .set-form {
    .form-item {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
      .item-lable {
        display: inline-block;
        width: 100px;
        text-align: end;
      }
    }
  }
  .drawer-wrap {
    /deep/.el-drawer__header {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.95);
      font-weight: bold;
      margin-bottom: 22px;
    }
  }
  .icon-content {
    width: 100px;
    height: 100px;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f5f6f7;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-upload {
      display: block;
      text-align: center;
      color: #1890ff;
      font-size: 28px;
    }
    .icon-img {
      width: 100%;
      height: 100%;
    }
    .cover-btn {
      position: absolute;
    }
  }
  .app-list {
    border-top: 1px solid rgb(232, 234, 236);
    padding: 24px 12px 0px 12px;
    max-height: 300px;
    overflow: auto;
    .app-item {
      width: 33%;
      margin-right: 0px;
      height: 60px;
      /deep/ .el-checkbox__input {
        height: 48px;
      }
      /deep/ .el-checkbox__label {
        display: inline-flex;
        align-items: center;
      }
      .app-pic {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        margin-right: 10px;
      }
      .app-name {
        width: 75px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        word-break: break-all;
        white-space: break-spaces;
        font-size: 12px;
      }
    }
  }
}
</style>
<style lang="less">
.base-set-wrap-count-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .count-option {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .count-item {
      display: block;
      line-height: 20px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
</style>
